import { useState } from 'react';
import { motion } from 'framer-motion';
import confetti from 'canvas-confetti';
import PaymentModal from './PaymentModal';
import './App.css';

function App() {
  const [celebrated, setCelebrated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const triggerConfetti = () => {
    setCelebrated(true);

    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    const random = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(function () {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      // since particles fall down, start a bit higher than random
      confetti({
        ...defaults,
        particleCount,
        origin: { x: random(0.1, 0.3), y: Math.random() - 0.2 }
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: random(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 250);
  };

  return (
    <div className="App">
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div
          className="image-container"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
        >
          {/* Using the user specified image from public folder */}
          <img src="/von.jpeg" alt="Von Kahela" className="profile-image" />
        </motion.div>

        <motion.h1
          className="title"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Happy Birthday
          <br />
          Von Kahela! 👑
        </motion.h1>

        <motion.p
          className="subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          Celebrating a Legend, a Visionary, and a True Inspiration! 🚀
        </motion.p>

        <motion.div
          className="message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
        >
          Today we celebrate the one and only Von Kahela. Your journey inspires us all.
          <br /><br />
          Let's make this day unforgettable! Show your love and appreciation by sending a gift to fuel the legend's next big adventure.
          Every gesture counts! ✨
        </motion.div>

        <div className="button-group">
          <motion.button
            className="btn-celebrate"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={triggerConfetti}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1 }}
          >
            {celebrated ? "Wohooo! 🎉" : "Make a Wish! 🎂"}
          </motion.button>

          <motion.button
            className="btn-gift"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsModalOpen(true)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2 }}
          >
            Send Gift 🎁
          </motion.button>
        </div>
      </motion.div>

      <PaymentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default App;
